import $ from "jquery";

$("#lightboxModal").on("show.bs.modal", function (event) {
  var button = $(event.relatedTarget); // Button or link that triggered the modal
  var imageurl = button.data("imageurl"); // Extract info from data-* attributes
  var alttext = button.data("alttext"); // Extract info from data-* attributes
  var imagecaption = button.data("imagecaption"); // Extract info from data-* attributes
  // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
  // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
  var modal = $(this);
  modal.find(".modal-body img").attr('src', imageurl);
  modal.find(".modal-body source").attr('srcset', imageurl);
  modal.find(".modal-body a").attr('href', imageurl);
  modal.find(".modal-body img").attr('alt', alttext);
  modal.find(".modal-footer .image-caption").html(imagecaption);
});
